import { render, staticRenderFns } from "./gameResultRescueExportFull.vue?vue&type=template&id=4ed19055&lang=pug"
import script from "./gameResultRescueExportFull.vue?vue&type=script&lang=js"
export * from "./gameResultRescueExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports